/** @format */

import React, { useState, useEffect } from "react";
import {
  Modal,
  Upload,
  Button,
  Alert,
  Table,
  Tag,
  Space,
  Descriptions,
  Tooltip,
} from "antd";
import type { UploadProps } from "antd";
import moment from "moment";
import {
  editPengajuanVerifikasiDokumenBos,
  getPlanningAll,
} from "../../../../../services/v2/planningservice";
import {
  deleteDokumenRencanaDefinitif,
  editDokumenRencanaDefinitif,
  getDokumenRencanaDefinitif,
  postDokumenRencanaDefinitif,
} from "../../../../../services/v2/planningservice/rencanapendapatandefinitif";
import {
  formatRupiah,
  // openInNewTab,
  uuidv4,
} from "../../../../../utils/helper";
import {
  checkDataErkam,
  checkDataLpj,
  checkDataNilai,
  getFilesDokByKode,
  getKodeDokLintasBatch,
  // getBeforeSumberDanaTahap,
  getNamePenerimaBOS,
  getStatusDokumen,
  getSumberDanaTahap,
  normalizeNamaDok,
  spesialBOSTahap2,
} from "../../../../../utils/helper/helperBos";
import {
  CopyOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
  ReloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  ButtonTableDelete,
  ButtonTableDetail,
  ButtonTableDownload,
} from "../../../../../components/Button";
import axios from "axios";
import { planningService } from "../../../../../services/v2/constant";
import { getReferenceAll } from "../../../../../services/v2/referenceservice";
import { useDispatch, useSelector } from "react-redux";
import { getLaporanErkam } from "../../../../../services/v2/planningservice/laporanservices";
import { setStore } from "../../../../../redux/actions";
import {
  getLaporanPengembalianDanaAxios,
  getReportAll,
} from "../../../../../services/v2/reportservice";
import ModalLihatDokumenBos from "../../../../../components/Modal/ModalLihatDokumenBos";
// import ModalGenerateDoc from "../../../PaguInd/Belanja/Component/ModalGenerateDoc";
import ModalDokumenAction from "../../../../../components/Modal/ModalActionDokumen";
import ModalDoubleDokumenBos from "../../../../../components/Modal/ModalDoubleDocument";

export const baseURL: string =
  window.REACT_APP_API_URL || "https://api-gateway.erkam-v2.kemenag.go.id/api";
// "https://staging-api-gateway.erkam-v2.kemenag.go.id/api";
export const publicURL: string =
  window.REACT_APP_PUBLIC_URL ||
  "https://staging-frontend.erkam-v2.kemenag.go.id/";

type FormModalActionType = {
  dataSumber: any;
  realisasiPendapatanHeader: any;
  openModal: boolean;
  auth: any;
  hanldeClose: () => void;
};

const ModalDokumenBos = ({
  dataSumber,
  realisasiPendapatanHeader,
  openModal,
  auth,
  hanldeClose,
}: FormModalActionType) => {
  const dispatch = useDispatch();
  const store = useSelector((state: any) => state.store);
  const bos = useSelector((state: any) => state.bos);
  const dataTableDokumen: any = bos.filePengajuanBos || [];
  const tmpJadwalPengajuan = bos.jadwalPengajuanBos || [];
  const typePenerimaBOS = getNamePenerimaBOS();
  const listDoc = ["docLpj", "docTBUP", "docRkam"];
  const [loading, setLoading] = useState<any>(false);
  const [statusBos, setStatusBos] = useState<any>(null);
  const [title, setTitle] = useState("");
  const [idUpload, setIdUpload] = useState<any>(null);
  const [verificationButton, setVerificationButton] = useState<any>(false);
  const [dataPencairan, setDataPencairan] = useState<any>(null);
  const [fileList, setFileList] = useState<any>([]);
  const [fileUpload, setFileUpload] = useState<any>(null);
  const [dataBos, setDataBos] = useState<any>(null);
  const [nilaiPencairan, setNilaiPencairan] = useState<any>(null);
  const [nilaiPengembalianDana, setNilaiPengembalianDana] = useState<any>(null);
  const [dataRealisasiHeader, setDataRealisasiHeader] = useState<any>(null);
  const [dataLaporan, setDataLaporan] = useState<any>([]);
  const [pdfFile, setPdfFile] = useState<any>(null);
  const [dataAction, setDataAction] = useState<any>(null);
  const [fileDoubleDok, setFileDoubleDok] = useState<any>([]);
  const tmpLaporanRKAM = store.laporanRKAM || [];
  const tmpRencanaPendapatan = store.rencanaPendapatanDefinitif || [];
  const [statusDokumen, setStatusDokumen] = useState<any>(getStatusDokumen(0));

  const [messageInformation, setMessageInformation] = useState<any>(null);
  const [openModalPriview, setOpenModalPriview] = useState(false);
  const [openModalAction, setOpenModalAction] = useState(false);
  const [openModalDataDouble, setOpenModalDataDouble] = useState(false);
  const tmpSpesialBOSTahap2: any = spesialBOSTahap2() || [];
  const checkDataMadrasah: any = tmpSpesialBOSTahap2.includes(
    auth?.madrasah?.nsm,
  );
  const showAlert = checkDataErkam(dataLaporan, tmpRencanaPendapatan);
  let lastKodeSumberDana: any =
    tmpJadwalPengajuan
      .sort((a, b) => a.sumberdana.localeCompare(b.sumberdana))
      .at(-1) || null;

  const getJadwal =
    tmpJadwalPengajuan
      .sort(
        (a, b) =>
          new Date(b.start_date).getTime() - new Date(a.start_date).getTime(),
      )
      .find((item) => item?.sumberdana === dataSumber?.kode_sumber_dana) ||
    null;

  // Dokumen wajib dimiliki oleh TAHAP, bukan oleh satu batch pengajuan. Satu
  // tahap bisa punya beberapa batch, dan admin mendefinisikan ulang baris
  // dokumen (kode_id baru) tiap batch dibuka — jadi scope-nya seluruh batch
  // milik sumber dana ini, bukan hanya batch yang sedang berjalan.
  const jadwalIdsTahap =
    tmpJadwalPengajuan
      .filter((item) => item?.sumberdana === dataSumber?.kode_sumber_dana)
      .map((item) => item?.id) || [];

  const startJadwal = (id: any) =>
    new Date(
      tmpJadwalPengajuan.find((item) => item?.id === id)?.start_date || 0,
    ).getTime();

  // Satu baris per dokumen wajib untuk seluruh tahap. Bila dokumen yang sama
  // didefinisikan di beberapa batch, baris batch terbaru yang dipakai supaya
  // upload baru memakai kode_id batch yang sedang berjalan.
  const dataTableDoc: any[] = Array.from(
    dataTableDokumen
      .filter(
        (item) =>
          item?.penerima_bos?.toString() === statusBos?.toString() &&
          jadwalIdsTahap.includes(item?.djadwal_pengajuan_id),
      )
      .sort(
        (a, b) =>
          startJadwal(a?.djadwal_pengajuan_id) -
          startJadwal(b?.djadwal_pengajuan_id),
      )
      .reduce(
        (acc, item) => acc.set(normalizeNamaDok(item?.nama), item),
        new Map<string, any>(),
      )
      .values(),
  );

  const getKodeDokRecord = (record: any) =>
    getKodeDokLintasBatch(dataTableDokumen, record, jadwalIdsTahap, statusBos);

  /**
   * Cari file yang mewakili 1 baris dokumen wajib. Dokumen batch aktif
   * diprioritaskan (ambil yang paling baru diupload bila terupload double),
   * baru kemudian dokumen dari batch lain untuk dokumen logis yang sama.
   */
  const resolveFileDok = (record: any) => {
    const tahap = getSumberDanaTahap(dataSumber?.kode_sumber_dana);
    const [kodeAktif, ...siblingKodeIds] = getKodeDokRecord(record);

    const exact =
      getFilesDokByKode(fileList, [kodeAktif], tahap, statusBos)[0] || null;
    if (exact) return exact;

    if (!siblingKodeIds.length) return null;

    // Dokumen dari batch lain dalam tahap yang sama tetap dibawa apapun
    // statusnya (Belum Disetujui/DiTolak/Disetujui) — sama seperti sisi
    // verifikator (ModalListDokumenBos.tsx) — supaya dokumen yang sudah
    // diverifikasi tidak balik jadi "Dokumen Kosong" hanya karena batch
    // pengajuan lain dibuka dan madrasah belum re-upload di batch tsb.
    return (
      getFilesDokByKode(fileList, siblingKodeIds, tahap, statusBos)[0] || null
    );
  };

  const checkDokLpj =
    (dataTableDoc.length &&
      dataTableDoc.find((item) => item.kode === "docLpj")) ||
    null;

  const getDataRealisasi = async (values: any) => {
    if (values && auth?.isTahun !== values?.periode?.isYear) {
      const tmpRealisasiPendapatanHeader =
        (await getReportAll("pendapatan/header", {
          tahun: values?.periode?.isYear,
        })) || null;
      setDataRealisasiHeader(tmpRealisasiPendapatanHeader);
    } else {
      setDataRealisasiHeader(realisasiPendapatanHeader);
    }
  };

  useEffect(() => {
    if (checkDokLpj) {
      getDataRealisasi(checkDokLpj);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkDokLpj]);

  const alertLpj = checkDataLpj(dataRealisasiHeader, dataSumber, checkDokLpj);

  useEffect(() => {
    buttonValidation();
    if (fileList?.length) {
      let fileDataPenerima: any =
        fileList?.find(
          (item: any) =>
            item.kodeSumberDana === dataSumber?.kode_sumber_dana &&
            item.tahap === getSumberDanaTahap(dataSumber?.kode_sumber_dana),
        ) || null;

      if (fileDataPenerima) {
        setStatusBos(fileDataPenerima?.penerimaBos);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusBos, fileList, nilaiPengembalianDana, dataSumber, dataPencairan]);

  useEffect(() => {
    getPortalBos(dataSumber);
    getDataDokumen();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSumber]);

  const getPortalBos = async (values: any) => {
    const dataPortalBos = await getPlanningAll("portal-bos", {
      nsm: auth?.madrasah?.nsm,
      tahun: auth?.isTahun,
    });

    const dataRekBos =
      (await getReferenceAll("rekening-portalbos", {
        activated: 1,
        nsm: auth?.madrasah?.nsm,
        tahun: auth?.isTahun,
      })) || [];

    // setDataRekBos(dataRekBos);

    getStatusPencairan(
      getSumberDanaTahap(dataSumber?.kode_sumber_dana),
      dataRekBos,
    );

    const tmpTotalNilai =
      (dataPortalBos &&
        dataPortalBos["apbn_bos_semester1"] +
          dataPortalBos["apbn_bos_semester2"] +
          dataPortalBos["apbn_bos_triwulan1"] +
          dataPortalBos["apbn_bos_triwulan2"] +
          dataPortalBos["apbn_bos_triwulan3"] +
          dataPortalBos["apbn_bos_triwulan4"]) ||
      "1";

    const tahunLpj: any = auth?.isTahun - 1;
    const tmpNilaiPengambalianDana: any = await getLaporanPengembalianDanaAxios(
      tahunLpj,
      auth,
      auth?.madrasah?.id,
    );
    setNilaiPengembalianDana(tmpNilaiPengambalianDana || { sisa: 0 });

    if (
      tmpLaporanRKAM.length === 0 ||
      tmpLaporanRKAM[0].tahun !== auth?.isTahun
    ) {
      const laporanRKAM = await getLaporanErkam({
        tahun: auth?.isTahun,
        madrasahId: auth?.madrasah?.id,
      });

      setTimeout(() => {
        dispatch(setStore({ laporanRKAM }));
      }, 100);
      setDataLaporan(laporanRKAM || []);
    } else {
      setDataLaporan(tmpLaporanRKAM || []);
    }

    setNilaiPencairan(tmpTotalNilai);
    setDataBos(dataPortalBos || null);
    setDataAction({
      tahap: getSumberDanaTahap(dataSumber?.kode_sumber_dana),
      checkDataMadrasah: checkDataMadrasah,
      auth: auth,
      dataJadwalBOS: getJadwal,
      madrasahId: auth?.madrasah?.id,
      status: "s",
    });
  };

  const getStatusPencairan = async (tahap: any, daRek: any) => {
    axios
      .get(
        `${baseURL}${planningService}/dokumen-pencairan/nsm?tahun=${auth?.isTahun}&nsm=${auth?.madrasah?.nsm}&tahap=${tahap}`,
        {
          withCredentials: false,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers":
              "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-Erkam-Year",
            "Access-Control-Allow-Credentials": true,
            Authorization: "Bearer " + auth?.token,
            "X-Erkam-Year": auth?.isTahun,
          },
        },
      )
      .then(function (response: any) {
        if (response?.data?.return) {
          let res: any = response?.data?.return;
          const dataRek: any =
            daRek.find((item) => item.nsm === auth?.madrasah?.nsm) || null;
          let dataTmp: any = {
            ...res,
            namaBank: dataRek?.nama_bank,
            namaRekening: dataRek?.no_rekening_nama,
            noRekening: dataRek?.no_rekening,
            alamat: auth?.madrasah?.alamat_jalan,
          };
          // console.log(dataTmp);
          setDataPencairan(dataTmp);
        } else {
          setDataPencairan(null);
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };

  const handleAjukanVerifikasi = async () => {
    setLoading(true);
    let payload: any = {
      tahap: getSumberDanaTahap(dataSumber?.kode_sumber_dana),
      tahun: auth?.isTahun,
      nsm: auth?.madrasah?.nsm,
      keterangan: null,
      statusPenerimaBos: statusBos,
    };

    try {
      await editPengajuanVerifikasiDokumenBos(payload);
      Modal.success({
        title: "Sukses",
        content: "Dokumen Berhasil diajukan ke verifikator",
        centered: true,
        wrapClassName: "erkam-custom-modal",
      });
      handleBeforeClose();
      getDataDokumen();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getDataDokumen = async () => {
    setLoading(true);
    let params: any = `?tahun=${auth?.isTahun}&madrasahId=${auth?.madrasah?.id}`;
    try {
      const res = await getDokumenRencanaDefinitif(params);
      let result: any =
        (res?.length &&
          res.filter(
            (item) =>
              item?.jenisMadrasah === "R" &&
              item.kodeSumberDana === dataSumber?.kode_sumber_dana &&
              item.tahap === getSumberDanaTahap(dataSumber?.kode_sumber_dana),
          )) ||
        [];
      setFileList(result || []);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const uploadFile = async (params) => {
    setLoading(true);

    let fileData: any = new FormData();
    fileData.append("id", idUpload);
    fileData.append("file", params.file);
    fileData.append("kodeSumberDana", dataSumber?.kode_sumber_dana);
    fileData.append("namaSumberDana", dataSumber?.nama_sumber_dana);
    fileData.append("keterangan", "");
    fileData.append("tahun", auth.isTahun);
    fileData.append("kodeDok", fileUpload.kode_id);
    fileData.append("namaDok", params.file.name);
    fileData.append("rencanaPendapatanId", dataSumber?.id);
    fileData.append("jenisMadrasah", "R");
    fileData.append("penerimaBos", statusBos);
    fileData.append("tahap", getSumberDanaTahap(dataSumber?.kode_sumber_dana));
    if (fileUpload?.jenis_doc === "dokumen") {
      if (title === "upload") {
        try {
          await postDokumenRencanaDefinitif(fileData);
          getDataDokumen();
          Modal.success({
            title: "Sukses",
            content: "Dokumen berhasil upload",
            centered: true,
            wrapClassName: "erkam-custom-modal",
          });
          return params;
        } catch (error) {
          console.log(error);
          Modal.error({
            title: "Gagal",
            content:
              "Maaf, sedang ada kesalahan pada sisi server. coba beberapa saat lagi",
            okType: "danger",
            centered: true,
            wrapClassName: "erkam-custom-modal",
          });
        }
      } else {
        try {
          await editDokumenRencanaDefinitif(fileData, idUpload);
          getDataDokumen();
          Modal.success({
            title: "Sukses",
            content: "Dokumen berhasil upload",
            centered: true,
            wrapClassName: "erkam-custom-modal",
          });
          return params;
        } catch (error) {
          console.log(error);
          Modal.error({
            title: "Gagal",
            content:
              "Maaf, sedang ada kesalahan pada sisi server. coba beberapa saat lagi",
            okType: "danger",
            centered: true,
            wrapClassName: "erkam-custom-modal",
          });
        }
      }
    }

    setLoading(false);
  };

  const props: UploadProps = {
    name: "file",
    customRequest: uploadFile,
    accept: "application/pdf",
    showUploadList: false,
    headers: {
      authorization: "authorization-text",
    },
    beforeUpload: (file) => {
      let isPDF = file.type === "application/pdf";
      const maxFile = file.size >= 2000000 ? false : true;
      if (!isPDF) {
        Modal.warning({
          title: "Peringatan!",
          content: "Dokumen yang di upload harus .pdf",
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
      }
      if (!maxFile) {
        Modal.warning({
          title: "Peringatan!",
          content: "Maksimal file 2M",
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
        isPDF = false;
      }
      return isPDF || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        Modal.success({
          title: "Sukses",
          content: `${info.file.name} file berhasil upload`,
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
      } else if (info.file.status === "error") {
        Modal.error({
          title: "Kesalahan",
          content: `${info.file.name} file gagal upload.`,
          okType: "danger",
          centered: true,
          wrapClassName: "erkam-custom-modal",
        });
      }
    },
    progress: {
      strokeColor: {
        "0%": "#108ee9",
        "100%": "#87d068",
      },
      strokeWidth: 3,
      format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
    },
  };

  let columnsDokumen: any = [
    {
      title: "Nama",
      dataIndex: "nama",
      width: 110,
      key: "nama",
    },
    {
      title: "Nama File",
      key: "namaFile",
      width: 110,
      render: (record) => {
        let namaFile = resolveFileDok(record);

        if (record.kode === "docBPD") {
          let infoPengembalian: any =
            (nilaiPengembalianDana?.sisa !== 0 && (
              <div className="text-red-500">{`Lampirkan bukti pengembalian dana sebesar saldo  transaksi ${formatRupiah(
                nilaiPengembalianDana?.sisa,
              )}`}</div>
            )) ||
            "";
          return (
            (namaFile && namaFile?.namaDok && namaFile?.namaDok) ||
            infoPengembalian
          );
        } else {
          return (namaFile?.namaDok && `${namaFile?.namaDok}`) || "";
        }
      },
    },
    {
      title: "Tanggal Upload",
      key: "tanggalUpload",
      width: 70,
      render: (record) => {
        let namaFile = resolveFileDok(record);

        return (
          (namaFile?.updated_at &&
            moment(namaFile?.created_at).format("DD MMM YYYY")) ||
          ""
        );
      },
    },
    {
      title: "Tanggal Verifikasi",
      key: "tanggalVerifikasi",
      width: 70,
      render: (record) => {
        let namaFile = resolveFileDok(record);
        return (
          (namaFile?.statusValidasi.toString() === "1" &&
            namaFile?.tanggal_verifikasi_dokumen &&
            moment(namaFile?.tanggal_verifikasi_dokumen).format(
              "DD MMM YYYY",
            )) ||
          "" ||
          ""
        );
      },
    },
    {
      title: "Keterangan",
      width: 150,
      key: "keterangan",
      render: (record, i) => {
        let namaFile = resolveFileDok(record);

        if (record.kode === "docRkam" && showAlert) {
          return (
            <div key={`al${i}`} className="mb-4">
              <Alert
                className="mb-4"
                message={
                  <>
                    Rencana belanja definitif belum sesuai dengan rencana
                    pendapatan.
                  </>
                }
                type="error"
                showIcon
              />
            </div>
          );
        } else if (record.kode === "docLpj" && alertLpj) {
          return (
            <div key={`al${i}`} className="mb-4">
              <Alert
                className="mb-4"
                message={alertLpj}
                type="error"
                showIcon
              />
            </div>
          );
        } else {
          return (namaFile?.keterangan && namaFile?.keterangan) || "";
        }
      },
    },
    {
      title: "Status",
      width: 80,
      key: "statusValidasi",
      render: (record) => {
        let namaFile = resolveFileDok(record);

        if (!["docLpj", "docRkam"].includes(record?.kode)) {
          return namaFile ? (
            <Tag
              color={
                (namaFile?.statusValidasi.toString() === "2" && "red") ||
                (namaFile?.statusValidasi.toString() === "1" && "#008000") ||
                "#ffca27"
              }>
              {(namaFile?.statusValidasi.toString() === "2" && "DiTolak") ||
                (namaFile?.statusValidasi.toString() === "1" && "Disetujui") ||
                "Belum Disetujui"}
            </Tag>
          ) : record?.key !== "docTBUP" ? (
            <Tag>Dokumen Kosong</Tag>
          ) : (
            <Tag
              color={dataPencairan?.statusPencairan === 3 ? "#008000" : "gray"}>
              {dataPencairan?.statusPencairan === 3
                ? "Disetujui"
                : "Belum Disetujui"}
            </Tag>
          );
        }
      },
    },
    {
      title: "Upload (Max 2M)",
      key: "upload",
      fixed: "right",
      width: 140,
      render: (record, i) => {
        let namaFile = resolveFileDok(record);
        let doubleDok: any = getFilesDokByKode(
          fileList,
          getKodeDokRecord(record),
          getSumberDanaTahap(dataSumber?.kode_sumber_dana),
          statusBos,
        );

        let linkDoc: any =
          (record?.jenis_doc === "dokumen" && record?.namatemplate) || null;

        return (
          <Space>
            {!namaFile ? (
              !listDoc.includes(record?.kode) ? (
                <>
                  {record?.kode !== "docBPD" ? (
                    <Upload key={`up${i}`} maxCount={1} {...props}>
                      <Button
                        loading={loading}
                        icon={<UploadOutlined />}
                        onClick={() => handleAfterUpload(record)}>
                        Upload
                      </Button>
                    </Upload>
                  ) : (
                    (nilaiPengembalianDana?.sisa !== 0 && (
                      <Upload key={`up${i}`} maxCount={1} {...props}>
                        <Button
                          icon={<UploadOutlined />}
                          onClick={() => handleAfterUpload(record)}>
                          Upload
                        </Button>
                      </Upload>
                    )) ||
                    ""
                  )}
                </>
              ) : (
                <Button
                  key={`up${i}`}
                  icon={
                    record?.kode !== "docTBUP" ? (
                      <ReloadOutlined />
                    ) : (
                      <DownloadOutlined />
                    )
                  }
                  onClick={() => handleAction(record?.kode)}
                  disabled={
                    record?.kode !== "docTBUP"
                      ? false
                      : dataPencairan?.statusPencairan === 3
                        ? false
                        : true
                  }>
                  {record?.kode !== "docTBUP" ? "Lihat Data" : "Download"}
                </Button>
              )
            ) : (
              <>
                {!listDoc.includes(record?.kode) ? (
                  <>
                    <ButtonTableDetail
                      key={`td${i}`}
                      tooltips="Lihat Dokumen"
                      loading={loading}
                      onClick={() => priviewDoc(namaFile.namaFile)}
                    />
                    <ButtonTableDelete
                      key={`tup${i}`}
                      disabled={
                        (namaFile?.statusValidasi?.toString() === "1" &&
                          true) ||
                        // (namaFile?.statusVerifikasiDokumen?.toString() ===
                        //   "1" &&
                        //   true) ||
                        false
                      }
                      onClick={() => {
                        Modal.confirm({
                          title: "Perhatian",
                          content: "Yakin Hapus Data?",
                          onOk() {
                            return handleDeleteUpload(namaFile.id);
                          },
                          onCancel() {},
                          okText: "Hapus",
                          cancelText: "Batal",
                          okType: "danger",
                          centered: true,
                          wrapClassName: "erkam-custom-modal",
                        });
                      }}
                    />
                    {doubleDok.length >= 2 && (
                      <Tooltip key={`tuol${i}`} title="Double Dokumen">
                        <Button
                          onClick={() => handleDoubleDokumen(doubleDok)}
                          icon={<CopyOutlined />}
                        />
                      </Tooltip>
                    )}
                  </>
                ) : (
                  <Button
                    key={`buol${i}`}
                    icon={
                      record?.kode !== "docTBUP" ? (
                        <ReloadOutlined />
                      ) : (
                        <DownloadOutlined />
                      )
                    }
                    disabled={
                      record?.kode !== "docTBUP"
                        ? false
                        : dataPencairan?.statusPencairan === 3
                          ? false
                          : true
                    }
                    onClick={() => handleAction(record?.kode)}>
                    {record?.kode !== "docTBUP" ? "Lihat Data" : "Download"}
                  </Button>
                )}
              </>
            )}
            {linkDoc && (
              <ButtonTableDownload onClick={() => priviewDoc(linkDoc)} />
            )}
          </Space>
        );
      },
    },
  ];

  const getDownloadDokumen = async (params: any) => {
    axios
      .get(
        `${baseURL}${planningService}/dokumen-rencana-definitif/download?fileName=${params}`,
        {
          withCredentials: false,
          responseType: "arraybuffer",

          headers: {
            Accept: "application/pdf",
            "Content-Type": "application/pdf",
            "Access-Control-Allow-Headers":
              "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,X-Erkam-Year",
            "Access-Control-Allow-Credentials": true,
            Authorization: "Bearer " + auth?.token,
            "X-Erkam-Year": auth?.isTahun,
          },
        },
      )
      .then(function (response: any) {
        setOpenModalPriview(true);
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        setPdfFile(link);
        setLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        setLoading(false);
      });
  };

  const priviewDoc = async (params: any) => {
    try {
      setLoading(true);
      await getDownloadDokumen(params);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteUpload = async (idFile: any) => {
    try {
      await deleteDokumenRencanaDefinitif(idFile);
      Modal.success({
        title: "Sukses",
        content: "Penghapusan Dokumen Berhasil",
        centered: true,
        wrapClassName: "erkam-custom-modal",
      });
      getDataDokumen();
    } catch (error) {
      console.log(error);
      Modal.error({
        title: "Gagal",
        content:
          "Maaf, sedang ada kesalahan pada sisi server. coba beberapa saat lagi",
        okType: "danger",
        centered: true,
        wrapClassName: "erkam-custom-modal",
      });
    }
  };

  const handleAfterUpload = (record: any) => {
    setFileUpload(record);
    setTitle("upload");
    setIdUpload(uuidv4());
  };

  const handleAction = async (action: any) => {
    setOpenModalAction(true);
    setTitle(action);
  };

  const handleDoubleDokumen = (fileDouble: any) => {
    setFileDoubleDok(fileDouble);
    setOpenModalDataDouble(true);
  };

  const handleDeleteAction = async (values) => {
    const res = await deleteDokumenRencanaDefinitif(values?.id);
    if (res) {
      let fileDoubleTmp: any =
        fileDoubleDok.filter((item) => item.id !== values.id) || [];
      setFileDoubleDok(fileDoubleTmp);
      Modal.success({
        title: "Sukses",
        content: "Dokumen berhasil dihapus",
        centered: true,
        wrapClassName: "erkam-custom-modal",
      });
      getDataDokumen();
      // handleDokumen(dataMadrasah, dataMadrasah?.tahap);
    }
  };

  const handleBeforeClose = () => {
    hanldeClose();
    setStatusBos(null);
  };

  const buttonValidation = () => {
    // Dokumen wajib dari batch aktif, di-resolve lewat `resolveFileDok` supaya
    // dokumen yang diupload pada batch pengajuan sebelumnya (kode_id berbeda)
    // tetap terhitung lengkap — sama seperti yang tampil di tabel.
    let listVerifikasiDoc: any =
      (dataTableDoc.length &&
        dataTableDoc.filter(
          (item) => !["docRkam", "docLpj"].includes(item.kode),
        )) ||
      [];

    let dataFileTmp: any = listVerifikasiDoc.map((item) => resolveFileDok(item));

    handleVerifikasiDokumen(dataFileTmp);
  };

  const handleVerifikasiDokumen = (arrDoc: any) => {
    let validTolak: any =
      arrDoc.find((item: any) => item?.statusValidasi?.toString() === "2") ||
      null;

    let dokumenLengkap: boolean = !arrDoc.some((item: any) => !item);
    let validVerifikasi: any =
      arrDoc.find(
        (item: any) => item?.statusVerifikasiDokumen?.toString() === "1",
      ) || null;
    if (dataPencairan) {
      setVerificationButton(true);
      setStatusDokumen(
        getStatusDokumen(
          (dataPencairan?.statusPencairan === 1 && 3) ||
            (dataPencairan?.statusPencairan === 2 && 5) ||
            (dataPencairan?.statusPencairan === 3 && 6) ||
            (dataPencairan?.statusPencairan === 4 && 7),
        ),
      );
      return;
    }

    if (validVerifikasi) {
      setStatusDokumen(getStatusDokumen(2));
      setVerificationButton(true);
      return;
    }

    if (
      moment().isAfter(getJadwal?.start_date) &&
      moment().isBefore(getJadwal?.end_date_pengajuan) &&
      getJadwal?.sumberdana === dataSumber?.kode_sumber_dana
    ) {
      let textInformation: any = (
        <div className="text-green-500 font-bold">
          Pengajuan BOS sumber dana {dataSumber?.nama_sumber_dana} sedang
          berjalan di mulai dari{" "}
          {moment(getJadwal?.start_date).format("DD MMMM YYYY")} sampai dengan{" "}
          {moment(getJadwal?.end_date_pengajuan).format("DD MMMM YYYY ")} pukul
          {moment(getJadwal?.end_date_pengajuan).format(" HH.mm")} WIB
        </div>
      );
      setMessageInformation(textInformation);
      if (validTolak) {
        setStatusDokumen(getStatusDokumen(1));
        setVerificationButton(true);
      } else if (!dokumenLengkap) {
        setVerificationButton(true);
      } else if (showAlert) {
        setStatusDokumen(getStatusDokumen(0));
        setVerificationButton(true);
        return;
      } else if (alertLpj) {
        setVerificationButton(true);
      } else {
        setStatusDokumen(getStatusDokumen(0));
        setVerificationButton(false);
      }
    } else {
      let textInformation: any = (
        <div className="text-red-500 font-bold">
          Batas Pengajuan BOS {dataSumber?.nama_sumber_dana} akan berakhir pada{" "}
          {moment(getJadwal?.end_date_pengajuan).format("DD MMMM YYYY")} pukul
          {moment(getJadwal?.end_date_pengajuan).format(" HH.mm")} WIB
        </div>
      );
      setMessageInformation(textInformation);
      setVerificationButton(true);
    }
  };

  const handleCloseDouble = () => {
    setOpenModalDataDouble(false);
    setFileDoubleDok(null);
  };

  return (
    <Modal
      open={openModal}
      title={`Upload Dokumen  ${dataSumber?.nama_sumber_dana}`}
      width={1300}
      onCancel={handleBeforeClose}
      footer={[
        <Button key="back" onClick={handleBeforeClose}>
          Kembali
        </Button>,
        statusBos && statusBos !== "bukanPenerimaTahap1" && (
          <Button
            key="ajk"
            loading={loading}
            disabled={verificationButton}
            onClick={handleAjukanVerifikasi}
            type="primary">
            Ajukan Verifikasi
          </Button>
        ),
      ]}>
      {!statusBos ? (
        <>
          {/* <div className="text-center mb-4">
            {(["apbn_bos_semester_1", "apbn_bos_triwulan_1"].includes(
              dataSumber?.kode_sumber_dana,
            ) &&
              `Apakah Madrasah sudah pernah menerima bantuan Dana BOS TA.
          ${auth?.isTahun - 1}`) ||
              `Apakah Madrasah sudah pernah menerima bantuan Dana BOS Tahap/Triwulan
          TA.${auth?.isTahun} sebelumnya`}
            ?
          </div> */}
          <div className="text-center text-lg font-bold mb-4">
            Pilih Kriteria Penerima BOS untuk T.A {auth?.isTahun} dengan
            menyesuaikan Kriteria Sebelum nya.
          </div>
          <div className="grid grid-cols-2 gap-4 ">
            {/* <Button type="primary" onClick={() => setStatusBos(1)}>
              {(["apbn_bos_semester_1", "apbn_bos_triwulan_1"].includes(
                dataSumber?.kode_sumber_dana,
              ) &&
                `Penerima ${dataSumber?.nama_sumber_dana} TA.${
                  auth?.isTahun - 1
                }`) ||
                `Penerima ${getBeforeSumberDanaTahap(
                  dataSumber?.kode_sumber_dana,
                )}  TA.${auth?.isTahun}`}
            </Button> */}
            {getJadwal &&
              getJadwal?.jenisPenerima?.length &&
              getJadwal?.jenisPenerima?.map((items: any) => {
                let tmpKriteriaPenerima: any =
                  typePenerimaBOS.find((i) => i.kode.toString() === items) ||
                  null;

                return (
                  <Button
                    type="primary"
                    style={{
                      whiteSpace: "normal",
                      height: "auto",
                      marginBottom: "10px",
                    }}
                    onClick={() =>
                      // setStatusBos(
                      //   (["apbn_bos_semester_1", "apbn_bos_triwulan_1"].includes(
                      //     dataSumber?.kode_sumber_dana,
                      //   ) &&
                      //     3) ||
                      //   "bukanPenerimaTahap1",
                      // )
                      setStatusBos(tmpKriteriaPenerima?.kode || "")
                    }>
                    {/* {(["apbn_bos_semester_1", "apbn_bos_triwulan_1"].includes(
                      dataSumber?.kode_sumber_dana,
                    ) &&
                      `Bukan Penerima  ${dataSumber?.nama_sumber_dana} TA.${auth?.isTahun - 1
                      }`) ||
                      `Bukan Penerima  ${getBeforeSumberDanaTahap(
                        dataSumber?.kode_sumber_dana,
                      )} TA.${auth?.isTahun}`} */}
                    {`${tmpKriteriaPenerima?.name}`}
                    <Tooltip title={`${tmpKriteriaPenerima?.desc}`}>
                      <InfoCircleOutlined
                        style={{ marginLeft: 8 }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Tooltip>
                  </Button>
                );
              })}
          </div>
        </>
      ) : (
        // ) : statusBos === "bukanPenerimaTahap1" ? (
        //   <>
        //     <div className="text-center mb-4">
        //       Apakah Madrasah sudah pernah menerima bantuan Dana BOS TA.
        //       {auth?.isTahun - 1} ?
        //     </div>
        //     <div className="grid grid-cols-2 gap-4 ">
        //       <Button type="primary" onClick={() => setStatusBos(2)}>
        //         Penerima BOS TA.{auth?.isTahun - 1}
        //       </Button>
        //       <Button type="primary" onClick={() => setStatusBos(3)}>
        //         Penerima BOS Baru TA.{auth?.isTahun}
        //       </Button>
        //     </div>
        //   </>
        <>
          <div className="flex items-center justify-center mb-4">
            <div className="flex-none text-center">
              <div className="mb-2 text-xl font-bold">
                {auth?.madrasah?.nama || ""}
              </div>
              <Descriptions layout="vertical" bordered column={5}>
                <Descriptions.Item
                  label={`Alokasi Dana BOS TA. ${auth?.isTahun}`}>
                  <div className="mb-2 text-xl font-bold">
                    {formatRupiah(nilaiPencairan)}
                  </div>
                </Descriptions.Item>
                <Descriptions.Item
                  label={`Nominal ${dataSumber?.nama_sumber_dana}`}>
                  <div className="mb-2 text-xl font-bold">
                    {formatRupiah(
                      checkDataNilai(dataBos, dataSumber?.kode_sumber_dana),
                    )}
                  </div>
                </Descriptions.Item>
                {/* {dataPencairan?.tahap === 2 && dataPencairan?.batch === 1 && (
                  <>
                    <Descriptions.Item label={`Nominal Non AA`}>
                      <div className="mb-2 text-xl font-bold">
                        {formatRupiah(
                          checkDataNilai(
                            dataBos,
                            dataSumber?.kode_sumber_dana,
                          ) - dataBos?.nilai_aa,
                        )}
                      </div>
                    </Descriptions.Item>
                    <Descriptions.Item label={`Nominal AA`}>
                      <div className="mb-2 text-xl font-bold">
                        {formatRupiah(dataBos?.nilai_aa)}
                      </div>
                    </Descriptions.Item>
                  </>
                )} */}
                <Descriptions.Item label="Jumlah Siswa">
                  <div className="mb-2 text-xl font-bold">
                    {dataBos?.jumlahSiswa} Orang
                  </div>
                </Descriptions.Item>
              </Descriptions>
            </div>
          </div>
          <Table
            className="mb-2"
            columns={columnsDokumen}
            rowKey={(record) => record?.id}
            dataSource={dataTableDoc || []}
            loading={loading}
            scroll={{ x: 1200 }}
            bordered
            pagination={false}
          />
          <div className="text-xs mb-2">
            <div className="flex items-center gap-4">
              <div className="flex-auto">
                {(dataPencairan?.statusPencairan === 3 && (
                  <>
                    <Alert
                      message={<strong>Pengumuman Pengajuan</strong>}
                      description={
                        <div>
                          <div className="mb-2">
                            Selamat dokumen pengajuan madrasah telah{" "}
                            <span className="font-bold">Berhasil</span> dan
                            Selanjutnya silahkan mencairkan dana BOS melalui
                            bank penyalur masing masing dengan membawa bukti
                            upload pencairan.
                          </div>
                          <Button onClick={() => handleAction("docTBUP")}>
                            Unduh Bukti Pencairan
                          </Button>
                        </div>
                      }
                      type="success"
                      showIcon
                    />
                    {dataSumber?.kode_sumber_dana ===
                      lastKodeSumberDana?.sumberdana &&
                      dataBos?.nilai_optimalisasi > 0 && (
                        <Alert
                          className="mt-4"
                          message={
                            <strong>Penerima Dana BOS Optimalisasi</strong>
                          }
                          description={
                            <div>
                              <div className="mb-2">
                                Selamat madrasah telah mendapatkan{" "}
                                <span className="font-bold">
                                  Dana BOS Optimalisasi T.A {auth?.isTahun}
                                </span>{" "}
                                dan Selanjutnya silahkan mencairkan Dana BOS
                                Optimalisasi melalui bank penyalur masing masing
                                dengan membawa bukti upload pencairan.
                              </div>
                              <Button
                                onClick={() => handleAction("docOptimalisasi")}>
                                Unduh Bukti Pencairan
                              </Button>
                            </div>
                          }
                          type="info"
                          showIcon
                        />
                      )}
                  </>
                )) || (
                  <Alert
                    message={<strong>Informasi Pengajuan BOS</strong>}
                    description={
                      <div className="">
                        <div>
                          Print Bukti Upload dapat di akses ketika status
                          dokumen menjadi{" "}
                          <span className="font-bold">Pencairan</span>.
                        </div>
                        {messageInformation}
                      </div>
                    }
                    type="info"
                    showIcon
                  />
                )}
              </div>
              <div className="flex-initial p-5">
                <div className="text-lg text-center font-bold mb-2">
                  Status Dokumen
                </div>
                <div className="text-center">
                  <Tooltip title={statusDokumen?.status?.toolstips}>
                    <Tag color={statusDokumen?.status?.color}>
                      {statusDokumen?.status?.infoMessage}
                    </Tag>
                    {(dataPencairan?.statusPencairan === 1 && (
                      <div className="mt-2">
                        Tanggal Verifikasi:
                        {moment(dataPencairan?.created_at)
                          .utc()
                          .format("DD MMMM YYYY")}
                      </div>
                    )) ||
                      (dataPencairan?.statusPencairan > 1 && (
                        <>
                          <div className="mt-2">
                            Tanggal:{" "}
                            {moment(dataPencairan?.submissionDate)
                              .utc()
                              .format("DD MMMM YYYY")}
                          </div>
                        </>
                      ))}
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          <ModalLihatDokumenBos
            onClose={() => setOpenModalPriview(!openModalPriview)}
            openModalPriview={openModalPriview}
            pdfFile={pdfFile}
          />

          <ModalDokumenAction
            openModal={openModalAction}
            dataAction={dataPencairan}
            dataLaporan={dataLaporan}
            dataFile={fileList}
            dataBOS={dataBos}
            dataSumber={dataSumber}
            dataDokumen={dataTableDoc}
            dataMadrasah={dataAction}
            showAlert={showAlert}
            onClose={() => setOpenModalAction(false)}
            action={title}
          />

          <ModalDoubleDokumenBos
            openModalDataDouble={openModalDataDouble}
            loading={loading}
            onPriview={priviewDoc}
            onDeleteFile={handleDeleteAction}
            fileDoubleDok={fileDoubleDok}
            onClose={handleCloseDouble}
          />
        </>
      )}
    </Modal>
  );
};
export default ModalDokumenBos;
